import { QRCodeCanvas, QRCodeSVG } from 'qrcode.react';

// EL ÚNICO SITIO DE TODA LA APLICACIÓN QUE DIBUJA UN QR.
//
// ===================================================================
// UN QR NO ES UN ELEMENTO DE INTERFAZ: ES TINTA SOBRE PAPEL
// ===================================================================
//
// El defecto, encontrado en el navegador: en tema oscuro los códigos no
// se escaneaban. Los módulos salían bien —negro sobre blanco— pero el QR
// se pintaba SIN zona de silencio, y el margen se lo daba la tarjeta:
// una tarjeta `bg-white`, que en oscuro vale `#191b20`. Es decir, el
// código quedaba pegado a un borde negro por los cuatro lados.
//
// Un lector necesita cuatro módulos de blanco alrededor para encontrar
// dónde empieza el código. Sin ellos falla aunque los módulos estén
// perfectos — y falla en silencio, dando «no leí nada», que es lo que
// mandó a alguien a pensar que la etiqueta estaba mal impresa.
//
// De ahí las tres reglas de este archivo, y por qué son literales:
//
//   1. TINTA NEGRA SOBRE PAPEL BLANCO, SIEMPRE. La polaridad invertida
//      no la leen muchos escáneres, y menos los de almacén.
//   2. ZONA DE SILENCIO PROPIA, de cuatro módulos, dibujada DENTRO del
//      código. Así no depende de con qué lo rodeen.
//   3. NINGÚN COLOR SALE DE UNA VARIABLE DE TEMA. Ni `bg-white`, ni
//      `var(--color-*)`, ni `currentColor`. El tema puede cambiar el
//      marco de la tarjeta; el código, nunca.
//
// Hay una prueba —`pruebas/qr.test.js`— que impide que se dibuje un QR
// fuera de aquí y que aquí entre un color de tema. Cierra por forma y no
// por lista: mañana habrá otra pantalla con otro QR, y no hace falta que
// nadie se acuerde de esto.

/** Negro puro. No es `--color-gray-900` ni `text-black`: es tinta. */
const TINTA = '#000000';
/** Blanco puro. NO es `bg-white`, que en tema oscuro vale `#191b20`. */
const PAPEL = '#FFFFFF';
/** Módulos de blanco alrededor. Cuatro es el mínimo de la norma. */
const SILENCIO = 4;

/**
 * Un código QR legible por un escáner, salga donde salga.
 *
 * `lienzo` lo dibuja en <canvas> en vez de <svg>, que es lo que hace
 * falta para exportarlo a PNG.
 */
export default function CodigoQR({
  valor, tamano = 120, lienzo = false, etiqueta,
}) {
  const Componente = lienzo ? QRCodeCanvas : QRCodeSVG;
  return (
    // El papel también aquí, por si el redondeo de un borde dejara un
    // hilo del fondo asomando entre el marco y la zona de silencio.
    <span
      style={{ background: PAPEL, display: 'inline-block', lineHeight: 0 }}
      role={etiqueta ? 'img' : undefined}
      aria-label={etiqueta}
    >
      <Componente
        value={valor}
        size={tamano}
        level="M"
        fgColor={TINTA}
        bgColor={PAPEL}
        marginSize={SILENCIO}
      />
    </span>
  );
}

export { TINTA, PAPEL, SILENCIO };
